import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { DualViewSetting } from '../../types';
import type { DualViewSettingModel } from '../dual-view-setting-model';

@injectable()
export class DualViewSettingModelImpl extends AbstractModel<DualViewSetting> implements DualViewSettingModel {
    protected _modelData: DualViewSetting = {
        left: [],
        right: [],
    };
}
